import React from "react";
import { useNavigate } from "react-router-dom";
import OrderForm from "../../components/orders/OrderForm";
import OrderSteps from "../../components/OrderSteps";
import { premiumPaths } from "../../navigation";

/** Prowadzi pierwszy krok świadectwa i otwiera zlecenie po przesłaniu dokumentów. */
export default function AddOrderPage({ organization, token }) {
  const navigate = useNavigate();
  return (
    <>
      <OrderSteps step={1} />
      <OrderForm
        organization={organization}
        token={token}
        onCreated={(order) => navigate(premiumPaths.order(order.id))}
      />
    </>
  );
}
